(function () {
    'use strict';

    angular.module("imApp").factory("sopService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1835,
                    parameters: parms || {}
                });
            },
            listFieldTypes: function (parms) {
                return $ihttp.post({
                    method: 1837,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1836,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
